var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var CommonUtils = require('../../utils/common-utils.js');

var Radio = require('backbone.radio');
var services = Radio.channel('services');
var notificationsChannel = Radio.channel('notifications');
var utils = new CommonUtils();

var DocumentSignStatisticRowView = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/statistics/document-sign-statistic-row.html'),

    ui: {
        documentsShow: '.documents-show'
    },

    events: {
        'click @ui.documentsShow': 'showDocuments'
    },

    templateContext: function () {
        var that = this;
        return {
        }
    },

    initialize: function (options) {
    },

    onRender: function () {

    },

    showDocuments: function() {
        this.triggerMethod('show:documents', this.model.get('documentsWithSignedDate'));
    }
});


var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(2), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});

var DocumentSignStatisticTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: DocumentSignStatisticRowView,
    emptyView: EmptyView,

    collectionEvents: {},

    childViewEvents: {
        'show:documents': 'showDocuments'
    },

    initialize: function (options) {
        this.collection = options.collection;
    },

    childViewOptions: function () {
        return {
        };
    },

    showDocuments: function(data) {
        this.triggerMethod('show:documents', data);
    }
});

var DocumentSignStatisticView = Marionette.View.extend({
    template: require('../../templates/statistics/document-sign-statistic-view.html'),

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        }
    },

    ui: {
        documentsShowModal: '#documents-show-modal',
        total: '#total',

        fromDateTime: '#from',
        toDateTime: '#to',
        filter: '#filter'
    },

    events: {
        'click @ui.filter': 'filter'
    },

    childViewEvents: {
        'show:documents': 'showDocuments'
    },

    templateContext: function () {
        var that = this;
        return {
            fromPlaceholder: that.forSigned ? 'Signed after' : 'Requested after',
            toPlaceholder: that.forSigned ? 'Signed before' : 'Requested before',
            signerTitle: that.forMd ? 'MD' : 'Organization',
            documentTitle: that.forSigned ? 'Signed documents' : 'Requested documents'
        }
    },


    initialize: function (options) {
        _.bindAll(this, 'showDocuments', 'getData', 'getRequestParameters', 'transformResponse', 'filter', 'resetTotal', 'getUrlPart');
        this.forSigned = options.forSigned;
        this.forMd = options.forMd;
    },

    onRender: function () {
        var that = this;

        that.ui.fromDateTime.datetimepicker({
        });
        that.ui.toDateTime.datetimepicker({
        });

        that.collection = new Backbone.Collection();

        var callback = function(response) {
            that.collection.reset(that.transformResponse(response));
            that.showChildView('body', new DocumentSignStatisticTableBody({
                collection: that.collection
            }));
            that.resetTotal(that.collection);
        }

        that.getData(callback);
    },

    filter: function() {
        var that = this;
        that.getData(function(response) {
            that.collection.reset(that.transformResponse(response));
            that.resetTotal(that.collection);
        });
    },

    getData: function(callback) {
        var that = this;

        utils.showSpinner();
        $.ajax({
            type: "GET",
            url: that.getUrlPart() + '?' + that.getRequestParameters(),
            statusCode: {
                200: function (response) {
                    utils.hideSpinner();
                    if (_.isFunction(callback)) {
                        callback(response);
                    }
                }
            },
            error: function(e) {
                utils.hideSpinner();
                notificationsChannel.request('show:notification', e.responseJSON);
            }
        });
    },

    transformResponse: function(response) {
        var transformed = _.keys(response).map(function(key) {
            var signerSplitted = utils.splitToPair(key, ":");
            return {
                signerId: signerSplitted[0],
                signerName: signerSplitted[1],
                documentsWithSignedDate: response[key]
            }
        });

        return _.sortBy(transformed, 'signerName');
    },

    getRequestParameters: function() {
        var params = {};

        if (this.ui.fromDateTime.val() != undefined && this.ui.fromDateTime.val() != '')
            params['from_actionTime'] = utils.dateToLong(this.ui.fromDateTime.val());
        if (this.ui.toDateTime.val() != undefined && this.ui.toDateTime.val() != '')
            params['to_actionTime'] = utils.dateToLong(this.ui.toDateTime.val());
        
        return _.keys(params).map(function(key) {
            return key + "=" + params[key];
        }).join('&');
    },

    showDocuments: function(documents) {
        var that = this;

        $('#documents-table tbody').empty();

        documents = _.sortBy(documents, 'right').reverse();
        documents.forEach(function (document) {
            var documentIdAndName = utils.splitToPair(document.middle, ":");
            var documentSignedTime = document.right;
            var newRowContent = '<tr id="' + documentIdAndName[0]
                + '"><td>' +  utils.longToDateTimeFormatted(Number(documentSignedTime), 'MMM DD YYYY hh:mm A')
                + '</td><td><a href="/#document/' + documentIdAndName[0] + '" target="_blank"><b>' + documentIdAndName[1]
                + '</b></a></td></tr>';

            $('#documents-table tbody').append(newRowContent);
        });

        this.ui.documentsShowModal.modal('show');
    },

    resetTotal: function(collection) {
        var total = 0;
        collection.models.forEach(function(model) {
            total = total + (model.attributes.documentsWithSignedDate || []).length;
        });
        this.ui.total.text(total);
    },

    getUrlPart: function() {
        return '/api/statistics/' + (this.forMd ? 'mds' : 'organizations') + '/documents/' + (this.forSigned ? 'signed' : 'requested');
    }

});

module.exports = DocumentSignStatisticView;


//////////////////
// WEBPACK FOOTER
// ./app/views/statistics/document-sign-statistic-view.js
// module id = 464
// module chunks = 0